import React from 'react';
import { IconProps } from '../types';
const MinecraftExposedCopperDoor: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="2" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(168, 119, 98, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(168, 119, 98, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(77, 80, 70, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(152, 140, 105, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(122, 152, 105, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(168, 119, 98, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(168, 119, 98, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(77, 80, 70, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(122, 152, 105, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(152, 140, 105, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(67, 67, 67, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(152, 140, 105, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(152, 140, 105, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(127, 114, 87, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(127, 114, 87, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(127, 114, 87, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(77, 80, 70, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(127, 114, 87, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(77, 80, 70, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(152, 140, 105, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(127, 114, 87, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(127, 114, 87, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(77, 80, 70, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(77, 80, 70, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(77, 80, 70, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(127, 114, 87, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(127, 114, 87, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(127, 114, 87, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(77, 80, 70, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(127, 114, 87, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(152, 140, 105, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(127, 114, 87, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(127, 114, 87, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(152, 140, 105, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(154, 119, 100, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(152, 140, 105, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(152, 140, 105, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(122, 152, 105, 255)" />
<rect x="12" y="14" width="1" height="1" fill="rgba(186, 130, 119, 255)" />
<rect x="3" y="15" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="4" y="15" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="5" y="15" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="6" y="15" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="10" y="15" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="11" y="15" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
<rect x="12" y="15" width="1" height="1" fill="rgba(121, 100, 84, 255)" />
</svg>);
export default MinecraftExposedCopperDoor;